import React from 'react';
// helpers
import * as G from '../../helpers';
// ui
import { Flex, AbsoluteBox } from '../../ui';
// component local-loader
import { Wrapper } from './ui';
//////////////////////////////////////////////////

const maskColor = G.getTheme('colors.transparentMask');

export const OverLoader = ({
  p,
  mr,
  mb,
  height,
  children,
  loaderOpen,
  opacity = 0.4,
  width = '100%',
  borderRadius = 0,
  bgColor = maskColor,
}) => (
  <Flex
    p={p}
    mb={mb}
    mr={mr}
    width={width}
    height={height}
    position='relative'
    justifyContent='center'
  >
    {
      children
    }
    {
      loaderOpen && (
      <AbsoluteBox
        width='100%'
        height='100%'
        justifyContent='center'
      >
        <AbsoluteBox
          width='100%'
          height='100%'
          opacity={opacity}
          backgroundColor={bgColor}
          borderRadius={borderRadius}
        />
        <Wrapper ><div /><div /><div /><div /></Wrapper>
      </AbsoluteBox>
    )}
  </Flex>
);

export default OverLoader;
